export function openFeedbackDialog(options = {}) {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent('app:open-feedback', { detail: options }))
}
